import { Collection } from "@mcleod/core";
import { LayoutDefinitionRetriever } from "./LayoutDefinitionRetriever";

/**
 * This class exists to provide access to clear layouts from the layout cache, without providing full access to the
 * cache itself.
 */
export class LayoutCacheAccessor {
    public static getCopy(): Collection<string> {
        return LayoutDefinitionRetriever.getCopyOfCache();
    }

    public static putAll(sourceCache: Collection<string>) {
        LayoutDefinitionRetriever.putAllInCache(sourceCache);
    }

    public static isEmpty(): boolean {
        return LayoutDefinitionRetriever.cacheIsEmpty();
    }
}
